import React, { useEffect, useMemo } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import './App.css'
import Home from './pages/Home'
import Work from './pages/Work'
import About from './pages/About'
import Contact from './pages/Contact'
import Nav from './components/nav'
import Editor from './pages/Editor'
import Library from './pages/Library'
import Login from './pages/Login'
import SideBarApp from './SideBarApp'
import NotFound from './pages/NotFound'
import useStorageState from 'react-use-storage-state'

function App() {
  const location = useLocation()
  const isSideBarApp = location.pathname.startsWith('/app')
  useEffect(() => {
    if (isSideBarApp) {
      document.body.classList.remove('full-screen')
    } else {
      document.body.classList.add('full-screen')
    }
  }, [isSideBarApp])
  return (
    <>
      {isSideBarApp ? null : <Nav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/app" element={<SideBarApp />}>
          <Route path="library" element={<Library />} />
          <Route path="editor" element={<Editor />} />
          <Route path="editor/:id" element={<Editor />} />
          <Route path="login" element={<Login />} />
        </Route>
        <Route path="/work" element={<Work />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}

export default App
